export default __webpack_public_path__ + "static/media/audio.b53c9c20.svg";